export const SKELETONS = {
  forecastDemand: {
    type: 'list-item-one-line, list-item',
    props: {
      class: 'mt-2 py-1', elevation: 2
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 83)
  },
  recommendationList: {
    type: 'list-item-two-line',
    props: {
      class: 'mt-2', elevation: 2
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 134)
  },
  manualConfigList: {
    type: 'list-item-two-line',
    props: {
      class: 'mt-2', elevation: 2
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 134)
  },
  menuRecommendationSelector: {
    type: 'list-item-one-line, list-item',
    props: {
      class: 'mt-2', elevation: 2
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 67)
  },
  menuList: {
    type: 'list-item-three-line, divider',
    props: {
      class: 'mb-0', elevation: 0
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 83)
  },
  menuEditorManaged: {
    type: 'list-item-two-line, divider',
    props: {
      class: 'mb-0', elevation: 0
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 67)
  },
  reporting: {
    type: 'list-item, date-picker-options',
    props: {
      class: 'mb-2', elevation: 2
    },
    numberOfSkeletons: (screenHeight) => Math.trunc((screenHeight - 170) / 134)
  },
  table: {
    type: 'table',
    props: {
      class: 'mb-2', elevation: 2
    },
    numberOfSkeletons: () => 1
  },
  default: {
    type: 'list-item-three-line, divider, list-item-three-line',
    props: {
      class: 'mb-0', elevation: 2
    },
    numberOfSkeletons: () => 1
  },
  get(field) {
    return this[field] || this.default;
  }
};
